export default __webpack_public_path__ + "static/media/sample.3579acbe.png";